import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Col, Row, Skeleton, Statistic } from 'antd';
import { isLoadingStatsPool, isLoadingStatsUser } from '../../../redux/selectors/stats';
import TranslatedText from '../../TranslatedText';
import {hashrateValue, hashrateUnit} from '../../../services/hashrate';

const Hashrates = ({ poolHashrate, userHashrate, userStatsLoading, poolStatsLoading }) => (
  <React.Fragment>
    <Card id="user-hashrate-card" title={<TranslatedText transKey="dashboard.hashrates.usertitle" />} bordered={false}>
      <Row>
        <Col xs={12} xl={12}>
          {userStatsLoading ? (
            <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 1, width: '50%' }} />
          ) : (
            <Statistic
              title={<TranslatedText transKey="dashboard.hashrates.realtime" />}
              value={hashrateValue(userHashrate.current)}
              suffix={hashrateUnit(userHashrate.current)}
              precision={3}
            />
          )}
        </Col>
        <Col xs={12} xl={12}>
          {userStatsLoading ? (
            <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 1, width: '50%' }} />
          ) : (
            <Statistic
              title={<TranslatedText transKey="dashboard.hashrates.24hrs" />}
              value={hashrateValue(userHashrate.dayAverage)}
              suffix={hashrateUnit(userHashrate.dayAverage)}
              precision={3}
            />
          )}
        </Col>
      </Row>
    </Card>
    <Card id="pool-hashrate-card" title={<TranslatedText transKey="dashboard.hashrates.pooltitle" />} bordered={false}>
      <Row>
        <Col xs={12} xl={12}>
          {poolStatsLoading ? (
            <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 1, width: '50%' }} />
          ) : (
            <Statistic
              title={<TranslatedText transKey="dashboard.hashrates.realtime" />}
              value={hashrateValue(poolHashrate.current)}
              suffix={hashrateUnit(poolHashrate.current)}
              precision={3}
            />
          )}
        </Col>
        <Col xs={12} xl={12}>
          {poolStatsLoading ? (
            <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 1, width: '50%' }} />
          ) : (
            <Statistic
              title={<TranslatedText transKey="dashboard.hashrates.24hrs" />}
              value={hashrateValue(poolHashrate.dayAverage)}
              suffix={hashrateUnit(poolHashrate.dayAverage)}
              precision={3}
            />
          )}
        </Col>
      </Row>
    </Card>
  </React.Fragment>
);

Hashrates.propTypes = {
  poolHashrate: PropTypes.shape({
    current: PropTypes.number,
    dayAverage: PropTypes.number,
  }),
  userHashrate: PropTypes.shape({
    current: PropTypes.number,
    dayAverage: PropTypes.number,
  }),
  userStatsLoading: PropTypes.bool,
  poolStatsLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  poolStatsLoading: isLoadingStatsPool(state),
  userStatsLoading: isLoadingStatsUser(state),
});

export default connect(mapStateToProps)(React.memo(Hashrates));



// WEBPACK FOOTER //
// /src/components/pages/dashboard/Hashrates.jsx